<template>
  <card-seplag titulo="Gestão de LP Comissionado">
    <div class="divBusca p-col-12">
      <div class="p-grid p-align-end p-justify-center">
        <Rotulo cols="12 3" nome="Orgão">
          <Dropdown
            v-model="orgaoSelecionado"
            :options="listaOrgao"
            optionLabel="labelDropDaw"
            placeholder="Selecione..."
            filter
            :disabled="listaOrgao.length == 0"
            @change="clicouOrgao()"
          />
        </Rotulo>
        <Rotulo cols="12 3" nome="Setor:">
          <Dropdown
            v-model="unidadeSelecionado"
            :options="listaUnidades"
            optionLabel="labelDropDaw"
            placeholder="Selecione..."
            filter
            showClear
            :disabled="!orgaoSelecionado || listaUnidades.length == 0"
            @change="clicouSetor()"
          />
        </Rotulo>
        <div class="p-md-2 p-col-12">
          <Button
            :disabled="
              disableBuscar ||
              (this.pagina.toUpperCase() == 'APROVADO' &&
                !this.unidadeSelecionado)
            "
            label="Buscar"
            icon="pi pi-search"
            class="p-button-info"
            @click="clicouBuscar()"
          />
        </div>
      </div>
    </div>
    <div class="p-grid p-col-12 botoes" v-if="orgaoSelecionado">
      <div class="p-md-6 p-col-12" @click="selecionarPagina('pendente')">
        <Card class="card-button estiloPendentes" v-if="mostrarPendentes">
          <template slot="content">
            <div class="p-grid">
              <div class="p-col-7">
                <span class="botao-titulo-status">Pendentes</span>
              </div>
            </div>
          </template>
        </Card>
        <Card class="card-button" v-else>
          <template slot="content">
            <div class="p-grid">
              <div class="p-col-7">
                <span class="botao-titulo-status">Pendentes</span>
              </div>
            </div>
          </template>
        </Card>
      </div>
      <div class="p-md-6 p-col-12" @click="selecionarPagina('aprovado')">
        <Card class="card-button estiloDeferidos" v-if="mostrarDeferidos">
          <template slot="content">
            <div class="p-grid">
              <div class="p-col-7">
                <span class="botao-titulo-status">Validados</span>
              </div>
            </div>
          </template>
        </Card>
        <Card class="card-button" v-else>
          <template slot="content">
            <div class="p-grid">
              <div class="p-col-7">
                <span class="botao-titulo-status">Validados</span>
              </div>
            </div>
          </template>
        </Card>
      </div>
    </div>
    <div
      class="p-col-12"
      v-if="
        listaServidores &&
        listaServidores.content &&
        listaServidores.content.length > 0
      "
    >
      <div class="p-col-12" style="margin-top: 10px" v-if="orgaoSelecionado">
        <div class="p-grid p-align-end p-justify-center">
          <Rotulo cols="12 3" nome="Filtro por Nome:">
            <InputText type="text" v-model="filtro" />
          </Rotulo>
          <div class="p-md-2 p-col-12">
            <Button
              label="Filtrar"
              icon="pi pi-filter"
              class="p-button-info"
              @click="carregarServidores()"
            />
          </div>
        </div>
      </div>
      <!-- :onSearchPaginacao="carregarDadosAgendamento" -->
      <table-seplag
        :dados="listaServidores.content"
        :exibirCabecalho="false"
        :campos="[]"
        :paginacao="true"
        :totalRegistro="listaServidores.totalElements"
        :onSearchPaginacao='paginacao'
      >
        <Column field="idRegPubl" header="ID">
          <template #body="slotProps">
            <p>
              {{ slotProps.data.idRegPubl ? slotProps.data.idRegPubl : "" }}
            </p>
          </template>
        </Column>
        <Column field="matricula" header="Matrícula">
          <template #body="slotProps">
            <p>{{ slotProps.data.matricula }}</p>
          </template>
        </Column>
        <Column
          field="nome"
          header="Nome Servidor"
          :bodyStyle="{ width: '30%' }"
        >
          <template #body="slotProps">
            <p>
              {{ slotProps.data.nome }}<br /><span
                style="font-size: 11px; font-weight: 700"
                >{{ slotProps.data.setor }}</span
              >
            </p>
          </template>
        </Column>
        <Column
          field="dataInicioDireitoAfastamento"
          header="Periodo Aquisitivo"
          headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento"
        >
          <template #body="slotProps">
            <span>
              {{ slotProps.data.dataInicioPeraq }} à
              {{ slotProps.data.dataFimPeraq }}</span
            >
          </template>
        </Column>
        <Column
          field="dataInicio"
          header="Periodo de Usufruto"
          headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento"
        >
          <template #body="slotProps">
            <span
              >{{ slotProps.data.dataInicio }} à
              {{ slotProps.data.dataFim }}</span
            >
          </template>
        </Column>
        <Column
          field="totalDias"
          header="Dias Solicitados"
          headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento"
        >
          <template #body="slotProps">
            <span> {{ slotProps.data.totalDias }}</span>
          </template>
        </Column>
        <Column field="origem" header="Origem">
          <template #body="slotProps">
            <p>{{ slotProps.data.origem }}</p>
          </template>
        </Column>
        <Column
          field="status"
          header="Situação"
          headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento"
        >
          <template #body="slotProps">
            <Button
              :label="slotProps.data.situacaoPortal"
              :class="
                'p-button-outlined customer-badge status-' +
                slotProps.data.situacao
              "
              @click="mostrarDetalhes(slotProps.data)"
            />
          </template>
        </Column>
        <Column
          headerStyle="width: 6em"
          bodyStyle="text-align: center;"
          header="Ação"
        >
          <template #body="slotProps">
            <Button
              type="button"
              icon="pi pi-id-card"
              v-tooltip.top="'Ação'"
              @click="showModal(slotProps.data)"
              :disabled="false"
              v-if="slotProps.data.origem == 'PORTALSERVIDOR'"
            ></Button>
          </template>
        </Column>
      </table-seplag>
    </div>
    <!-- MODAL DE APROVAÇÃO -->
    <cadastro-rapido
      v-if="habilitaAgendamento"
      :tituloTela="mostrarDeferidos ? 'Indeferir Férias' : 'Definir Ação'"
      v-model="exibirModalAprovacao"
      :modoEdicao="'adicionar'"
      :onAdicionar="validaRejeitaPedido"
      @fechar-modal="fecharModalValidaEscala"
      :textoButton="mostrarDeferidos ? 'Indeferir' : 'Salvar'"
    >
      <div class="p-col-12">
        <Fieldset v-if="servidorAprovacao">
          <template #legend>
            <strong>Servidor</strong>
          </template>
          <p>
            <strong>Matricula: </strong>
            {{ servidorAprovacao.matricula ? servidorAprovacao.matricula : "" }}
            - <strong>Vinculo: </strong>
            {{
              servidorAprovacao.numeroVinculo
                ? servidorAprovacao.numeroVinculo
                : ""
            }}
          </p>
          <p>
            <strong>Candidato: </strong>
            {{ servidorAprovacao.nome ? servidorAprovacao.nome : "" }}
          </p>
          <p>
            <strong>Periodo de Usufruto: </strong>
            {{
              servidorAprovacao.dataInicio ? servidorAprovacao.dataInicio : ""
            }}
            à {{ servidorAprovacao.dataFim ? servidorAprovacao.dataFim : "" }}
          </p>
          <p v-if="servidorAprovacao.dataInicioTemporario">
            <strong>Alterado para </strong
            >{{ servidorAprovacao.dataInicioTemporario }} à
            {{ servidorAprovacao.dataFimTemporario }}
          </p>
        </Fieldset>
      </div>
      <Rotulo nome="Deferido" cols="12" v-if="!mostrarDeferidos">
        <SelectButton
          name="deferido"
          v-model="registro.statusProgramacao"
          :options="simNao"
          optionLabel="name"
          v-required
        />
      </Rotulo>
      <Rotulo
        nome="Motivo Rejeição:"
        cols="12"
        v-if="registro.statusProgramacao.code == 'N'"
      >
        <Dropdown
          name="motivoRejeicao"
          v-model="registro.motivoRejeicao"
          :options="motivoRejeicao"
          v-required
        />
      </Rotulo>
      <Rotulo nome="Justificativa:" cols="12">
        <Textarea v-model="registro.obs" rows="5" cols="30" />
      </Rotulo>
    </cadastro-rapido>

    <!--Modal Detalhes-->
    <cadastro-rapido
      tituloTela="Detalhes"
      :tamanhoTela="'30.vw'"
      v-model="exibirDetalhes"
      textoButtonFechar="Fechar"
      :visivelbotao="true"
    >
      <p
        style="text-align: justify"
        v-html="detalhes ? detalhes : 'Não Informado'"
      />
    </cadastro-rapido>
  </card-seplag>
</template>

<script>
import CadastroRapido from "@/template/CadRapidoSeplag.vue";
import CardSeplag from "@/template/CardSeplag.vue";
import TableSeplag from "@/template/TableSeplag.vue";
import { baseApiUrl, simNao } from "@/config/global";
import Rotulo from "@/template/RotuloSeplag.vue";
import moment from "moment";

const getDefaulValida = () => {
  return {
    matriculaValidador: null,
    numeroVinculoValidador: null,
    idRegPubl: null,
    proximaSituacao: null,
    chaveperaqlesp: null,
    motivoRejeicao: null,
    chavePend: null,
    obs: null,
    statusProgramacao: { name: "Não", code: "N" },
  };
};

export default {
  name: "gestaoLPComissionado",
  components: { CardSeplag, Rotulo, TableSeplag, CadastroRapido },
  data: function () {
    return {
      listaOrgao: [],
      listaUnidades: [],
      orgaoSelecionado: null,
      unidadeSelecionado: null,
      disableBuscar: true,
      listaServidores: [],

      //Alternar paginas
      pagina: "pendente",
      mostrarPendentes: null,
      mostrarDeferidos: null,
      tituloTabela: "",

      //Filtro
      filtro: "",

      //usuario
      matricula: parseInt(this.$store.getters.getMatricula),
      vinculo: parseInt(this.$store.getters.getVinculo),

      //Detalhamento
      exibirDetalhes: false,
      detalhes: null,

      //Modal Aprovacao
      exibirModalAprovacao: false,
      servidorAprovacao: null,
      habilitaAgendamento: true,
      simNao: simNao,
      registro: getDefaulValida(),
      motivoRejeicao: [],

      //not used
      // dadosTabelaValidados: [],
      // apiUrlRecurso: "feriasview",
      // urlPaginacao: null,
      // totalRegistro: 0,
      // tamanhoPorpagina: 1000,
      // paginacaoTabela: '?size=1000&page=0',
    };
  },
  watch: {
    exibirModalAprovacao(novoValor, valorAntigo) {
      // O modal foi fechado se o novo valor for false e o valor antigo for true.
      if (novoValor === false && valorAntigo === true) {
        this.fecharModalValidaEscala();
      }
    },
  },
  methods: {
    validaRejeitaPedido() {
      this.registro.matriculaValidador = this.$store.getters.getMatricula;
      this.registro.numeroVinculoValidador = this.$store.getters.getVinculo;
      this.registro.chavePend = this.servidorAprovacao.chavePend;
      this.registro.chaveperaqlesp = this.servidorAprovacao.chaveperaqlesp;
      this.registro.idRegPubl = this.servidorAprovacao.idRegPubl;
      if (
        this.registro.statusProgramacao.code == "N" &&
        !this.registro.motivoRejeicao
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Informe o motivo da rejeição",
          life: 3000,
        });
        return;
      }
      if (this.registro.statusProgramacao.code == "N") {
        this.registro.proximaSituacao = "REJEITADO";
      } else {
        this.registro.proximaSituacao = "AUTORIZADO";
      }
      this.$http
        .post(
          `${baseApiUrl}/lincencaview/validarRejeitarLicenca`,
          JSON.stringify(this.registro)
        )
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: "Registro validado com sucesso",
            life: 3000,
          });
          this.fecharModalValidaEscala();
          this.carregarServidores();
        });
    },
    fecharModalValidaEscala() {
      this.registro = getDefaulValida();
      this.servidorAprovacao = null;
      this.exibirModalAprovacao = false;
    },
    showModal(servidor) {
      this.exibirModalAprovacao = true;
      this.servidorAprovacao = servidor;
    },
    mostrarDetalhes(servidor) {
      this.exibirDetalhes = false;
      this.detalhes = servidor.obs;
    },

    calcularTotalDias() {
      this.listaServidores.content.forEach((servidor) => {
        let startDate = moment(servidor.dataInicio, "DD/MM/YYYY");
        let endDate = moment(servidor.dataFim, "DD/MM/YYYY");
        servidor.totalDias = endDate.diff(startDate, "days") + 1;
      });
    },
    async carregarServidores(page=0, size=10) {
      if (this.orgaoSelecionado) {
        if (
          this.pagina.toUpperCase() == "APROVADO" &&
          !this.unidadeSelecionado
        ) {
          this.$toast.add({
            severity: "error",
            summary:
              "Seleção de Setor Obrigatório, Por favor Selecione um Setor",
            life: 3000,
          });
          return;
        }
        let bodyRequest = {
          matricula: this.matricula,
          numeroVinculo: this.vinculo,
          idenOrgao: this.orgaoSelecionado.idenOrgao,
          seapUnidade: this.unidadeSelecionado
            ? this.unidadeSelecionado.codgSeap
            : null,
          situacao: this.pagina.toUpperCase(),
          filtro: this.filtro,
        };
        const res = await this.$http.post(
          `${baseApiUrl}/lincencaview/listaOrgaoSetorGestorMax?page=${page}&size=${size}`,
          JSON.stringify(bodyRequest)
        );
        this.listaServidores = res.data;
        this.calcularTotalDias();
        const resMot = await this.$http.get(
          `${baseApiUrl}/lincencaview/validar/motivo/rejeicao`
        );
        this.motivoRejeicao = resMot.data;
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Seleção de Orgao Obrigatório, Por favor Selecione um Orgão",
          life: 3000,
        });
        return;
      }
    },
    carregarUnidades() {
      this.unidadeSelecionado = null;
      if (this.orgaoSelecionado) {
        this.$http
          .get(
            `${baseApiUrl}/feriasview/unidades/${this.orgaoSelecionado.idenOrgao}`
          )
          .then((res) => {
            this.listaUnidades = res.data.map(function (element) {
              return {
                ...element,
                labelDropDaw: element.codgSeap + " - " + element.siglUnidade,
              };
            });
          });
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Seleção de Orgao Obrigatório, Por favor Selecione um Orgão",
          life: 3000,
        });
        return;
      }
    },
    limparLista() {
      this.listaServidores = [];
    },
    alternarPaginas() {
      if (this.pagina == "pendente") {
        this.mostrarPendentes = true;
        this.mostrarDeferidos = false;
        this.tituloTabela = "Agendamentos Pendentes";
      } else if (this.pagina == "aprovado") {
        this.mostrarPendentes = false;
        this.mostrarDeferidos = true;
        this.tituloTabela = "Agendamentos Deferidos";
      }
      this.limparFiltro();
      this.limparLista();
    },
    limparFiltro() {
      this.filtro = "";
    },
    clicouOrgao() {
      this.disableBuscar = false;
      this.limparFiltro();
      this.alternarPaginas();
      this.carregarUnidades();
    },

    clicouSetor() {
      this.limparFiltro();
      //this.carregarServidores();
    },

    clicouBuscar() {
      this.limparFiltro();
      this.carregarServidores();
    },

    selecionarPagina(selected) {
      this.pagina = selected;
      this.limparFiltro();
      this.alternarPaginas();
    },

    carregarOrgaos() {
      this.$http.get(`${baseApiUrl}/feriasview/orgaosperfil`).then((res) => {
        this.listaOrgao = res.data.map(function (element) {
          return {
            ...element,
            labelDropDaw: element.codgSeap + " - " + element.siglUnidade,
          };
        });
      });
    },
    paginacao(rows,page){
      this.carregarServidores(page,rows);
    }
  },
  mounted() {
    // Carrega os dados do serviço
    this.carregarOrgaos();
  },
};
</script>

<style scoped>
.card-button {
  cursor: pointer;
}

.botao-titulo-status {
  font-size: 15px;
  font-weight: bold;
}

.estiloPendentes {
  background: rgb(219, 171, 81);
  color: aliceblue;
}

.estiloDeferidos {
  background: #0ca852;
  color: aliceblue;
}

.situacaoColunaFeriasAgendamento > div {
  justify-content: center;
}

.botaoColunaSituacaoFeriasAgendamento {
  text-align: center !important;
}
</style>
